// extracted by mini-css-extract-plugin
export default {"link":"root_navbar-link-module__link___J1emN","active":"root_navbar-link-module__active___lQ8Wo","icon":"root_navbar-link-module__icon___WlQld"};